export const STEPS = {
  products: 'products',
  file: 'file',
  answers: 'answers',
  summary: 'summary',
} as const;
